import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddPersonnelRequest } from '../models/request/personnel/AddPersonnelRequest';
import { GetPersonnelListPagingAndFilterRequest } from '../models/request/personnel/GetPersonnelListPagingAndFilterRequest';

export class PersonnelService {
    static async getPersonnelList(_dutyIds: string[] | undefined = undefined, _isCustomActive: boolean | undefined = undefined) {
        try {
            var inputObj = {
                dutyIds: _dutyIds,
                isCustomActive: _isCustomActive
            };

            console.log('SERVICE CALL - getPersonnelList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/getPersonnelList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /**
     * Siparis ekranindaki mesai tablosundan hizli personel tanimi.
     * Firma listeden secildiyse kimligi gonderilir; secilmediyse ad.
     */
    static async addPersonnelWithCompany(_nameSurname: string, _supplierCompanyId: string | undefined, _companyName?: string) {
        try {
            var inputObj = {
                nameSurname: _nameSurname,
                supplierCompanyId: _supplierCompanyId,
                companyName: _companyName,
            };

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/addPersonnelWithCompany', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Adiyla firmayi bulur ya da tedarikci olarak olusturur; secilebilsin diye kimligini doner. */
    static async getOrCreateSupplierCompany(_companyName: string) {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/getOrCreateSupplierCompany', { companyName: _companyName });

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportPersonnelList(inputObj: GetPersonnelListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportPersonnelList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/exportPersonnelList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getPersonnelListPagingAndFilter(inputObj: GetPersonnelListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetPersonnelListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/GetPersonnelListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addPersonnel(inputObj: AddPersonnelRequest) {
        try {
            console.log('SERVICE CALL - AddPersonnel', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/AddPersonnel', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deletePersonnel(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deletePersonnel', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/deletePersonnel', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getPersonnelById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getPersonnelById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Personnel/getPersonnelById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}